<template>
  <router-view/>
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Zen+Maru+Gothic:wght@400;500;700;900&family=Quicksand:wght@500;600;700&display=swap');

:root {
  /* ブランド4色（コーポレートロゴの S マーク由来） */
  --brand-blue: #0097E0;
  --brand-pink: #EE86A8;
  --brand-green: #8EC31F;
  --brand-red: #E83821;

  /* ソフト面 */
  --blue-bg: #e8f5ff;
  --pink-bg: #fef0f5;
  --green-bg: #f3fbe6;

  /* ベース / テキスト */
  --base: #fffdf7;
  --surface: #ffffff;
  --ink: #2b2b33;
  --ink-soft: #5f5e67;
  --ink-mute: #a8a6a0;
  --line: rgba(0, 0, 0, 0.07);
  --line-input: #ece8e0;
  --surface-soft: #faf8f3;

  /* フォント */
  --font-head: 'Zen Maru Gothic', 'Hiragino Maru Gothic ProN', 'Noto Sans JP', sans-serif;
  --font-lat: 'Quicksand', sans-serif;

  /* 形 */
  --radius: 16px;
  --radius-lg: 22px;
  --radius-pill: 999px;
}

* {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  background: var(--base);
}

#app {
  font-family: var(--font-head);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--ink);
  line-height: 1.75;
}

a {
  color: inherit;
}

h1, h2, h3, h4, p {
  margin: 0;
}

/* セクション見出しラベル（英字ピル） */
.rt-eyebrow {
  display: inline-block;
  font-family: var(--font-lat);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.14em;
  padding: 5px 14px;
  border-radius: var(--radius-pill);
  margin-bottom: 14px;
}

/* ピルボタン */
.rt-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: var(--font-head);
  font-weight: 700;
  font-size: 15px;
  text-decoration: none;
  border: none;
  cursor: pointer;
  padding: 12px 26px;
  border-radius: var(--radius-pill);
  transition: transform 0.15s ease, opacity 0.15s ease;
}

.rt-btn:hover {
  transform: translateY(-2px);
  opacity: 0.92;
}

.rt-btn--pink {
  background: var(--brand-pink);
  color: #fff;
}

.rt-btn--blue-outline {
  background: #fff;
  color: var(--brand-blue);
  border: 2px solid var(--brand-blue);
  padding: 10px 24px;
}

.rt-btn--ink {
  background: var(--ink);
  color: #fff;
}

/* セクション共通 */
.rt-section {
  padding: 64px 24px;
}

.rt-inner {
  max-width: 960px;
  margin: 0 auto;
}

.rt-section-head {
  text-align: center;
  margin-bottom: 28px;
}

.rt-section-title {
  font-size: 26px;
  font-weight: 700;
  color: var(--ink);
}

@media (max-width: 768px) {
  .rt-section {
    padding: 48px 18px;
  }
}
</style>
